import type { QuestionnaireResponseItem } from "@medplum/fhirtypes";

import {
  FETAL_HEART_RATE_ASSESS_BASELINE_LINK_ID,
  FETAL_HEART_RATE_ROOT_LINK_ID,
} from "@/encounters/components/EncounterLabor/constants/fetal-heart-rate-link-ids";
import { findQuestionnaireResponseItem } from "@/encounters/components/EncounterLabor/flowsheet-forms/shared/questionnaire-response-readers";

/**
 * Resolves the FHR questionnaire response root group.
 * Prefers linkId `fetalHeartRate`; falls back to item[0] only when that group contains
 * `assessBaseline` so an unrelated first item is not treated as the FHR root.
 */
export function resolveFetalHeartRateRootGroup(
  items: QuestionnaireResponseItem[] | undefined,
): QuestionnaireResponseItem | undefined {
  const rootByLinkId = findQuestionnaireResponseItem(items, FETAL_HEART_RATE_ROOT_LINK_ID);
  if (rootByLinkId) {
    return rootByLinkId;
  }

  const firstItem = items?.[0];
  if (
    firstItem &&
    findQuestionnaireResponseItem(firstItem.item, FETAL_HEART_RATE_ASSESS_BASELINE_LINK_ID)
  ) {
    return firstItem;
  }

  return undefined;
}
